import {FormioBase} from "./formiobase";

export class ComplexDataGrid extends FormioBase {
  public inputType = "datagrid";
  public title = "Complex nested block";
  public icon = "fab fa-wpforms";
  public shouldBeRenderedByFormio = false;
  public schema: any = {
    title: "Complex nested block",
    components: [{
      input: true,
      tree: true,
      components: [],
      tableView: true,
      label: "Complex nested block",
      key: undefined,
      protected: false,
      persistent: true,
      clearOnHide: true,
      type: "datagrid",
      inputType: "complexdatagrid",
      tags: [],
      customClass: "ds-complexdatagrid",
    }],
  };
}
